/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';
import { DxiSeriesComponent } from './series-dxi';



export class DxoChartComponent extends NestedOption {
    
    get barWidth(): number {
        return this._getOption('barWidth');
    }
    set barWidth(value: number) {
        this._setOption('barWidth', value);
    }

    
    get bottomIndent(): number {
        return this._getOption('bottomIndent');
    }
    set bottomIndent(value: number) {
        this._setOption('bottomIndent', value);
    }

    
    get commonSeriesSettings(): any {
        return this._getOption('commonSeriesSettings');
    }
    set commonSeriesSettings(value: any) {
        this._setOption('commonSeriesSettings', value);
    }

    
    get dataPrepareSettings(): any {
        return this._getOption('dataPrepareSettings');
    }
    set dataPrepareSettings(value: any) {
        this._setOption('dataPrepareSettings', value);
    }

    
    get equalBarWidth(): boolean {
        return this._getOption('equalBarWidth');
    }
    set equalBarWidth(value: boolean) {
        this._setOption('equalBarWidth', value);
    }

    
    get negativesAsZeroes(): boolean {
        return this._getOption('negativesAsZeroes');
    }
    set negativesAsZeroes(value: boolean) {
        this._setOption('negativesAsZeroes', value);
    }

    
    get palette(): string|
        Array<string> {
        return this._getOption('palette');
    }
    set palette(value: string|
        Array<string>) {
        this._setOption('palette', value);
    }

    
    get series(): any|
        Array<any> {
        return this._getOption('series');
    }
    set series(value: any|
        Array<any>) {
        this._setOption('series', value);
    }

    
    get seriesTemplate(): any {
        return this._getOption('seriesTemplate');
    }
    set seriesTemplate(value: any) {
        this._setOption('seriesTemplate', value);
    }

    
    get topIndent(): number {
        return this._getOption('topIndent');
    }
    set topIndent(value: number) {
        this._setOption('topIndent', value);
    }

    
    get useAggregation(): boolean {
        return this._getOption('useAggregation');
    }
    set useAggregation(value: boolean) {
        this._setOption('useAggregation', value);
    }

    
    get valueAxis(): any {
        return this._getOption('valueAxis');
    }
    set valueAxis(value: any) {
        this._setOption('valueAxis', value);
    }

    protected get _optionPath() {
        return 'chart';
    }


    
    get seriesChildren(): QueryList<DxiSeriesComponent> {
        return this._getOption('series');
    }
    set seriesChildren(value) {
        this.setChildren('series', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-chart',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'barWidth': [{ type: Input },],
'bottomIndent': [{ type: Input },],
'commonSeriesSettings': [{ type: Input },],
'dataPrepareSettings': [{ type: Input },],
'equalBarWidth': [{ type: Input },],
'negativesAsZeroes': [{ type: Input },],
'palette': [{ type: Input },],
'series': [{ type: Input },],
'seriesTemplate': [{ type: Input },],
'topIndent': [{ type: Input },],
'useAggregation': [{ type: Input },],
'valueAxis': [{ type: Input },],
'seriesChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiSeriesComponent), ] },],
};
}


export class DxoChartModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoChartComponent
  ],
  exports: [
    DxoChartComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
